import React from 'react';
import UserProfileForm from '../../../../../../../../../../components/forms/UserProfile';

const Active = ({ user, onSave, ...rest }) => {
    return <UserProfileForm onSubmit={onSave} user={user} {...rest} />;
};

export default Active;
